import device from 'current-device';
const initialState = {
    device: device.noConflict(),
};
export default function globalReducer(state = initialState, action) {
    return state;
}
